'use client'

/* eslint-disable @typescript-eslint/no-explicit-any */
import useSWR, { SWRConfiguration, SWRResponse } from 'swr'
import type { FetcherResponse } from 'swr/_internal'

import useHttpRequest from '@hooks/useHttpRequest'
import { basePath } from '@lib/constants'

import useLocale from './useLocale'

export default function useCustomSWR<T>(
  key: any,
  fetcher?: ((arg: any) => FetcherResponse<T>) | undefined,
  config?: SWRConfiguration,
): SWRResponse<T> {
  const locale = useLocale()
  const { clientFetch } = useHttpRequest()

  const internalFetcher =
    typeof fetcher !== 'undefined'
      ? fetcher
      : (resource: RequestInfo, init: RequestInit): unknown =>
          clientFetch(`${basePath}/api/${locale}${resource}`.replace(/\/\//g, '/'), init, 'json')

  return useSWR(key, internalFetcher, { revalidateOnFocus: false, ...config }) as SWRResponse<T>
}
